'use client';

import React from 'react';
import type { DelayedQuote } from '@benzinga/quotes-manager';

interface Props {
  quote?: DelayedQuote;
  isLoading: boolean;
}

function fmtPrice(price: number | null | undefined): string {
  if (price === null || price === undefined || !Number.isFinite(price)) return '—';
  return `$${price.toFixed(2)}`;
}

function fmtPct(pct: number | null | undefined): string | null {
  if (pct === null || pct === undefined || !Number.isFinite(pct)) return null;
  const sign = pct >= 0 ? '+' : '';
  return `${sign}${pct.toFixed(2)}%`;
}

export const PriceCell: React.FC<Props> = ({ quote, isLoading }) => {
  const price = quote?.lastTradePrice;
  const pct = quote?.changePercent;
  const pctStr = fmtPct(pct);
  const isUp = (pct ?? 0) >= 0;

  if (isLoading && !quote) {
    return <span className="whitespace-nowrap tabular-nums text-bzgray-500">…</span>;
  }

  return (
    <span className="whitespace-nowrap tabular-nums font-medium">
      <span>{fmtPrice(price)}</span>
      {pctStr ? <span className={isUp ? 'ml-1 text-bzgreen-500' : 'ml-1 text-bzred-500'}>({pctStr})</span> : null}
    </span>
  );
};
